
import React from 'react'
import { Button } from 'browser/components/atomic-elements/atoms/button/button'
import apis from 'browser/app/models/apis'
import './_impersonation-banner.scss'

export const ImpersonationBanner: React.FC = () => {
  if (!apis.getSettings().isImpersonating()) {
    return null
  }

  const stopImpersonating = () => {
    apis.stopImpersonation().then(() => {
      window.location.reload()
    })
  }

  return (
    <div className="c-impersonation-banner">
      You are currently impersonating another user.
      <Button buttonText="Stop Impersonating" onClick={stopImpersonating} />
    </div>
  )
}
